import React from 'react';
import '../style/Popup.css';

const Popup = ({ message, onClose }) => {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>&times;</button>
        <div className="content-scroll" dangerouslySetInnerHTML={{ __html: message }} />
        <button className="main-button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default Popup;